module.exports = __webpack_public_path__ + "img/MK.3e58f573.svg";